import { render, staticRenderFns } from "./partyDetail.vue?vue&type=template&id=320b1502"
import script from "./partyDetail.vue?vue&type=script&lang=js"
export * from "./partyDetail.vue?vue&type=script&lang=js"
import style0 from "./partyDetail.vue?vue&type=style&index=0&id=320b1502&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports